export const tr = {
    'empty-header': 'Başlangıç sözcük grupları yok',
    'empty-text': 'Başlangıç sözcük grupları ekleyin',
    'error-header': 'Sözcük grupları yüklenemedi'
};
